import React, { useState, useEffect } from 'react';
import {
    Form,
    Checkbox,
    Radio,
    Input,
} from 'antd';
import { getIcon } from '../utils/iconMap';

const { TextArea } = Input;

const ResourcesAndFocus = ({ contentTypes, options, isOnlineMode }) => {
    const { instructional = [], practice = [], assessment = [] } = contentTypes || {};
    const {
        classroomFormat = [],
        classroomResources = [],
        assessmentOptions = [],
        wellBeingOptions = []
    } = options || {};

    const form = Form.useFormInstance();
    const [selectedResources, setSelectedResources] = useState([]);

    useEffect(() => {
        const formValues = form.getFieldValue('selectedResources');
        if (formValues) {
            setSelectedResources(formValues);
        }
    }, [form]);

    const handleCheckboxChange = (checkedValues) => {
        setSelectedResources(checkedValues);
    };

    const allResources = [
        ...instructional.map(item => ({ ...item, category: 'Instructional' })),
        ...practice.map(item => ({ ...item, category: 'Practice' })),
        ...assessment.map(item => ({ ...item, category: 'Assessment' }))
    ];

    return (
        <div>
            <div className={'ch-lpm-form-section'}>
                <h3>Resources</h3>
                <Form.Item
                    name="selectedResources"
                    rules={[{ required: true, message: 'Please select at least one resource.' }]}
                >
                    <Checkbox.Group onChange={handleCheckboxChange} className="ch-lpm-resources-group">
                        <div className="ch-lpm-resources-grid">
                            {allResources.map((item) => (
                                <label
                                    key={item.value}
                                    className={`ch-lpm-resource-card ${selectedResources.includes(item.value) ? 'checked' : ''}`}
                                >
                                    <div className="ch-lpm-resource-card-content">
                                        {React.cloneElement(getIcon(item.icon), { className: 'ch-lpm-resource-card-icon' })}
                                        <span className="ch-lpm-resource-card-label">{item.label}</span>
                                        <Checkbox value={item.value} className="ch-lpm-resource-checkbox" />
                                    </div>
                                </label>
                            ))}
                        </div>
                    </Checkbox.Group>
                </Form.Item>
            </div>

            <div className={'ch-lpm-form-section'}>
                <h3>Delivery & Focus</h3>
            <Form.Item label="Primary Delivery Mode" name="classroomFormat" rules={[{ required: true }]}>
                <Radio.Group
                    buttonStyle={'solid'}
                >
                    {classroomFormat.map((mode) => (
                        <Radio.Button key={mode.value} value={mode.value}>
                            <div className="ch-lpm-radio-content">{getIcon(mode.icon)}{mode.label}</div>
                        </Radio.Button>
                    ))}
                </Radio.Group>
            </Form.Item>

            <Form.Item label="What resources are available in the classroom?" name="resourceProfile" rules={[{ required: true }]}>
                <Radio.Group
                    buttonStyle={'solid'}
                >
                    {classroomResources.map((item) => (
                        <Radio.Button key={item.value} value={item.value} disabled={isOnlineMode && item.value !== 'devices_1_to_1'}>
                            <div className="ch-lpm-radio-content">{getIcon(item.icon)}{item.label}</div>
                        </Radio.Button>
                    ))}
                </Radio.Group>
            </Form.Item>

            <Form.Item label="How will you primarily assess learning?" name="assessmentFitCategory" rules={[{ required: true }]}>
                <Radio.Group
                    buttonStyle={'solid'}
                >
                    {assessmentOptions.map((item) => (
                        <Radio.Button key={item.value} value={item.value}>
                            <div className="ch-lpm-radio-content">{getIcon(item.icon)}{item.label}</div>
                        </Radio.Button>
                    ))}
                </Radio.Group>
            </Form.Item>

            <Form.Item label="Student Well-being Focus (Optional)" name="wellBeingFocus">
                <Radio.Group
                    buttonStyle={'solid'}
                >
                    {wellBeingOptions.map((item) => (
                        <Radio.Button key={item.value} value={item.value}>
                            <div className="ch-lpm-radio-content">{getIcon(item.icon)}{item.label}</div>
                        </Radio.Button>
                    ))}
                </Radio.Group>
            </Form.Item>

                <Form.Item
                    label="Teacher's Note / Custom Instructions (Optional)"
                    name="customInstructions"
                >
                    <TextArea rows={4} placeholder="e.g., 'Please ensure the examples are related to sports statistics.'" />
                </Form.Item>
            </div>
        </div>
    );
};

export default ResourcesAndFocus;
